import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useToast } from '../hooks/use-toast';
import { Button } from './ui/button';

export default function ProductCard({ product }) {
  const { addItem } = useCart();
  const { toast } = useToast();

  const onAdd = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addItem(product, 1);
    toast({ title: 'Added to cart', description: product.name });
  };

  return (
    <div className="group bg-white rounded-lg border border-slate-200 overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
      <Link to={`/show/${product.id}`} className="block aspect-square bg-slate-50 overflow-hidden">
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </Link>
      <div className="p-5">
        <Link to={`/show/${product.id}`}>
          <h3 className="font-serif text-lg text-slate-800 hover:text-[#5d728c] transition-colors line-clamp-2 min-h-[3.5rem]">
            {product.name}
          </h3>
        </Link>
        <p className="text-sm text-slate-500 mt-1 line-clamp-2 min-h-[2.5rem]">{product.short}</p>
        <div className="mt-4 flex items-center justify-between">
          <span className="text-xl font-semibold text-slate-900">${product.price.toFixed(2)}</span>
          <div className="flex gap-2">
            <Button
              variant="outline"
              size="sm"
              className="border-slate-300 text-slate-700 hover:bg-slate-50"
              asChild
            >
              <Link to={`/show/${product.id}`}>View</Link>
            </Button>
            <Button
              size="sm"
              onClick={onAdd}
              className="bg-[#5d728c] hover:bg-[#4d6278] text-white"
            >
              Add
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
